import {
  MobilePlanCardsProductsQuery$data,
  OfferEligibilityLevelType,
} from '__generated__/MobilePlanCardsProductsQuery.graphql';
import { RelatedOfferFragment$data } from '__generated__/RelatedOfferFragment.graphql';

export type MobilePlanDetails =
  MobilePlanCardsProductsQuery$data['eligibleProductOffersByCategory']['category']['plans'][0];

export type MobilePlansDetails =
  MobilePlanCardsProductsQuery$data['eligibleProductOffersByCategory']['category']['plans'];

export type CtaOverride = MobilePlanDetails['ctaOverrides'];

export type PlanDetails = MobilePlanDetails;

export type PlansDetails = MobilePlansDetails;
export type RelatedOfferDetails = RelatedOfferFragment$data[0];

export enum OfferEligibilityLevelEnum {
  Line = 'Line',
  Account = 'Account',
  NA = 'NA',
}
export interface SelectedPlan {
  offerId: string;
  quantity: number;
  planName: string;
  price?: number;
  categoryIdentifiers?: readonly string[] | null;
  offerEligibilityLevel?: OfferEligibilityLevelType | null;
  isTeamUpEligible?: boolean;
  isPrimary?: boolean;
  relatedOfferId?: string | null;
  relatedOfferIds?: readonly string[] | null;
}

export interface EligibilityCount {
  available?: number;
  maximum?: number;
}
